<template>
  <div>
    <el-dropdown trigger="click" @command="handleSwitchLocale">
      <div class="switch-locale">
        <i class="iconfont icon-locale" />
        <span>{{ locale }}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item of locales"
          :key="item.value"
          :disabled="locale === item.value"
          :command="item.value"
        >
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locales: [
        { label: "Philippines", value: "PH" },
        { label: "Australia", value: "AUS" },
        // { label: "India", value: "IND" },
        { label: "Malaysia", value: "MYS" },
      ],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale.locale;
    },
  },
  methods: {
    handleSwitchLocale(locale) {
      const me = this;
      this.$confirm(`是否确认切换地区至: ${locale}`).then(() => {
        me.$store.dispatch("locale/changeLocale", locale);
        this.$message({
          duration: 500,
          type: "success",
          message: "切换地区成功",
          onClose() {
            window.location.reload();
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-locale {
  cursor: pointer;
  display: flex;
  align-items: center;
  i {
    font-size: 24px;
  }
  span {
    margin-left: 4px;
    font-size: 22px;
  }
}
</style>
